import { cn } from '@/shared/utils';

import TopScoreCard from '@/components/livescoring/TopScores/topScoreCard';
import { EmptyUI, ErrorUI } from '@/components/ui/ErrorEmptyUI';
import Loading from '@/components/ui/loading';
import useTopScores from '@/hooks/livescoring/useTopScores';

const RenderUI = ({ isLoading, data, goToLiveScores }) => {
  if (isLoading || !data) {
    return (
      <section className="w-full flex justify-center items-center h-[calc(100vh-300px)]">
        <Loading />
      </section>
    );
  }

  if (data?.length === 0) {
    return (
      <section className={cn('w-full flex justify-center items-center h-96')}>
        <EmptyUI
          title="Seems no top scores so far"
          description="Meanwhile check the live scores."
          buttonText="Go to live scores"
          onAction={goToLiveScores}
        />
      </section>
    );
  }

  return (
    <ul className="space-y-1">
      {data.map((game) => {
        return (
          <li key={game.blockId}>
            <TopScoreCard data={game} />
          </li>
        );
      })}
    </ul>
  );
};

const TopScores = () => {
  const { data, isLoading, isError, goToLiveScores } = useTopScores();

  if (isError) {
    return (
      <section className="w-full flex justify-center items-center h-[calc(100vh-300px)]">
        <ErrorUI
          title="We couldn't load top scores"
          description="Please check your internet connection and try again."
          onRetry={() => {}}
        />
      </section>
    );
  }

  return (
    <section className="max-w-[518px] mx-auto">
      <div
        className={cn(
          'max-md: pl-1',
          'flex justify-between items-center gap-8 h-16 relative'
        )}
      >
        <h1 className="text-2xl font-bold">Top scores</h1>
        {/* <TopScoreFilter
          labels={filters.labels}
          onSelect={filters.onChange}
          value={filters.selected}
        /> */}
      </div>

      <RenderUI
        isLoading={isLoading}
        data={data}
        goToLiveScores={goToLiveScores}
      />
    </section>
  );
};

export default TopScores;
